import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface INavItemProps extends TestingProps {
  children?: React.ReactNode;
  className?: string;
  isOpen?: boolean;
}

export const NavItem: React.FunctionComponent<INavItemProps> = ({
  isOpen = true,
  ...props
}) => {
  return (
    <li className={C('nav-item', props.className)} data-testid={props.testId}>
      {props.children}
    </li>
  );
};
